<template>

    <Toast/>

    <MenuLogin/>

    <div class="px-6 surface-overlay relative">

        <div class="border-2 surface-border border-round surface-section flex-auto">

            <div class="flex flex-wrap">

                <div v-show="activeTab === 1" class="w-full lg:w-12 p-4 lg:p-7 surface-card">
                    <div class="text-900 text-2xl font-medium mb-6">Forgot Your Password</div>

                    <div class="field">
                        <p class="text-600 line-height-3 mt-0 mb-4">
                            Enter your username below. If it matches the information on our application,
                            you'll receive an email to reset the password. Please check your email to complete your password reset.
                        </p>
                    </div>

                    <div class="field">
                        <label for="username" class="block text-900 font-medium mb-2">Username</label>
                        <InputText id="username" type="text" v-model="username" placeholder="Username"
                                   class="w-full mb-4"/>
                    </div>

                    <Button
                        label="Reset Password"
                        :disabled="!isFormValid"
                        class="p-3 w-full mt-auto custom-button"
                        :loading="submitted"
                        @click="processResetPassword"/>

                    <div class="mt-6 text-center text-600">
                        <a class="font-medium no-underline ml-2 text-teal-500 text-right cursor-pointer"
                           @click="handleCancel">Back to Login?</a>
                    </div>

                </div>

            </div>
        </div>

    </div>

    <IsoEvolveFooter/>

</template>

<script>
import IsoEvolveFooter from "@/components/heading/authentication/IsoEvolveFooter.vue";
import MenuLogin from "@/components/menu/authentication/MenuLogin.vue";
import UserService from "@/service/UserService";
import {useUserStore} from "@/stores/UserStore";

export default {
    components: {
        MenuLogin,
        IsoEvolveFooter
    },
    setup() {
        const userStore = useUserStore()

        return {
            userStore
        }
    },
    async mounted() {
        try {
            const userPingResponse = await UserService.getUserPing();
            console.log("[Login][mounted] System is active.");
            console.log("[Login][mounted] Data = ", userPingResponse);
        } catch (e) {
            console.log("[Login][mounted] System is NOT active.");
            console.log("[Login][mounted] Error = ", e);
            this.userStore.clearUser();
            this.$router.push("login");
            return;
        }

        this.activeTab = 1;
        this.submitted = false;
    },
    computed: {
        isFormValid() {
            // Check if all required fields are filled and email is valid
            return (
                this.username
            );
        },
    },
    data() {
        return {
            activeTab: 1,
            username: null,
            submitted: false
        }
    },
    methods: {
        async processResetPassword() {
            console.log("[ForgotPassword][processResetPassword] this.username = ", this.username);
            console.log("[ForgotPassword][processResetPassword] this.isFormValid = ", this.isFormValid);

            this.submitted = true;

            if (this.isFormValid) {

                try {
                    const response = await UserService.resetPassword(this.username);
                    console.log('[Pricing][processBuy] Response = ', response);

                    this.$toast.add({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'Successfully sent password reset email.',
                        life: 1000
                    });

                    setTimeout(() => {
                        window.location.href = "/#/login";
                    }, 1000); // 3000ms = 3 seconds

                } catch (e) {
                    console.error('[Pricing][processBuy] Error:', e);

                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to send password reset email. Please try again.',
                        life: 1000
                    });

                    setTimeout(() => {
                        window.location.href = "/#/login";
                    }, 1000); // 3000ms = 3 seconds
                }
            }

            this.submitted = false;
        },
        handleCancel() {
            this.activeTab = 1;
            console.log("[Login][handleForgotPassword] Start of function. Redirecting to functionality.");
            this.$toast.add({
                severity: 'success',
                summary: 'Successful',
                detail: 'Reset Back to Login',
                life: 1000
            });

            setTimeout(() => {
                window.location.href = "/#/login";
            }, 1000); // 3000ms = 3 seconds
        }
    }
}
</script>

<style scoped>
a {
    text-decoration: none;
}
</style>
